import React from 'react';
import { useExperiments } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { EOS_NEW_HEADER, MONETATE_DEFAULT_VARIANT } from 'constants/monetateExperiments';
import SiteHeader from '../SiteHeader';
import SiteHeaderNew from '../SiteHeaderNew';

export const SiteHeaderWrapper = () => {
  const { getExperimentById } = useExperiments();

  const { variant } = getExperimentById(EOS_NEW_HEADER.experiment);

  return variant === MONETATE_DEFAULT_VARIANT ? <SiteHeader /> : <SiteHeaderNew />;
};
